import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import ProtectedRoute from "@/components/site/ProtectedRoute";
import { AuthProvider } from "@/lib/auth";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Solutions from "@/pages/Solutions";
import ExecutiveFinancialCommand from "@/pages/ExecutiveFinancialCommand";
import TaxSchool from "@/pages/TaxSchool";
import TaxSchoolWelcome from "@/pages/TaxSchoolWelcome";
import TaxSchoolApply from "@/pages/TaxSchoolApply";
import Resources from "@/pages/Resources";
import Contact from "@/pages/Contact";
import Store from "@/pages/Store";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  return null;
}

function MarketingLayout({ children }) {
  return (
    <>
      <Header />
      <main data-testid="main-content">{children}</main>
      <Footer />
    </>
  );
}

function AdminLayout({ children }) {
  // No site Header/Footer for admin pages
  return <main data-testid="admin-main">{children}</main>;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Routes>
            {/* Admin (no marketing chrome) */}
            <Route path="/admin/login" element={<AdminLayout><AdminLogin /></AdminLayout>} />
            <Route
              path="/admin"
              element={
                <AdminLayout>
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                </AdminLayout>
              }
            />

            {/* Marketing pages */}
            <Route path="/" element={<MarketingLayout><Home /></MarketingLayout>} />
            <Route path="/about" element={<MarketingLayout><About /></MarketingLayout>} />
            <Route path="/solutions" element={<MarketingLayout><Solutions /></MarketingLayout>} />
            <Route path="/executive-financial-command" element={<MarketingLayout><ExecutiveFinancialCommand /></MarketingLayout>} />
            <Route path="/tax-school" element={<MarketingLayout><TaxSchool /></MarketingLayout>} />
            <Route path="/tax-school/apply" element={<MarketingLayout><TaxSchoolApply /></MarketingLayout>} />
            <Route path="/tax-school/welcome" element={<MarketingLayout><TaxSchoolWelcome /></MarketingLayout>} />
            <Route path="/resources" element={<MarketingLayout><Resources /></MarketingLayout>} />
            <Route path="/resources/:section" element={<MarketingLayout><Resources /></MarketingLayout>} />
            <Route path="/store" element={<MarketingLayout><Store /></MarketingLayout>} />
            <Route path="/contact" element={<MarketingLayout><Contact /></MarketingLayout>} />
            <Route path="*" element={<MarketingLayout><Home /></MarketingLayout>} />
          </Routes>
          <Toaster richColors position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
